
    import './styles.scoped.css';
    export default {
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_1udd3_9"
};
  